import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { StoreModel } from "models/StoreModel";
import { LoginUser } from "models/LoginUser";
import { ChangePasswordData, LoginUserActions } from "redux/actions/LoginUserActions";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import { ReactForm } from "app/components/common/Form";
import { withRouter } from "app/components/common/WithRouter";

interface Props {
    store: StoreModel;
    loginUser: LoginUser;
    setNewPassword: typeof LoginUserActions.setNewPassword;
    match: UrlParams;
}

interface UrlParams {
    params: {
        email?: string;
        token?: string;
    }
}

class SetNewPasswordComp extends React.Component<Props> {

    render() {
        let registerUser: ChangePasswordData = {eMail: unescape(this.props.match.params.email!), newPassword: "", confirmNewPassword: "", oldPassword:  decodeURI(unescape(this.props.match.params.token!)) }
        return (
            <div className="c-page__content">
                <PageContentHeader text="Set password for this new Account" />
                <div className="c-card">
                    <ReactForm
                        loginUser={this.props.loginUser}
                        formObject={registerUser!}
                        hidden={["oldPassword"]}
                        protected={["eMail"]}
                        store={this.props.store}
                        anonymous
                        callback={this.props.setNewPassword}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        store: state,
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        setNewPassword: bindActionCreators(LoginUserActions.setNewPassword, dispatch),
    };
}
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(SetNewPasswordComp));